import { render } from "./content-card-text-old.vue?vue&type=template&id=07c15203"
import script from "./content-card-text-old.vue?vue&type=script&lang=js"
export * from "./content-card-text-old.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__